import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../lib/firebase';

/**
 * Usuarios — Firestore Rules deniegan `list` en `users`.
 * Solo hay callable `getMyUserProfile` (perfil propio).
 * Un listado de empresa completo requiere una Cloud Function dedicada
 * en el backend; no se inventa aquí.
 */
export async function getMyProfile() {
  const fn = httpsCallable(functions, 'getMyUserProfile');
  const result = await fn({});
  return result?.data?.user || null;
}

/**
 * Intento de listado por RUC (igual que CajaScreen). Las Rules actuales
 * pueden rechazarlo; el caller debe mostrar un error amigable.
 */
export async function tryListCompanyUsers({ ruc, pageSize = 10 }) {
  if (!ruc) throw new Error('RUC requerido');
  const snap = await getDocs(
    query(collection(db, 'users'), where('ruc', '==', ruc), where('activo', '==', true), limit(pageSize))
  );
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
